/**
 * De teksten van de inspecteurskeuze. Eén keuze, drie plekken: "Nieuwe keuring",
 * het afspraakpaneel bij een keuring en het inspecteursfilter van de planning.
 */
export const inspectorPickerCopy = {
    pick: 'Kies een inspecteur',
    loading: 'Inspecteurs laden…',

    myself: 'Mijzelf',
    /** Onder "Mijzelf" als je nog geen rol op locatie hebt. */
    myselfNotYet: (name: string) => `${name} · nog geen inspecteur`,
    /** Onder een uitnodiging die nog openstaat: kiezen kan nog niet. */
    invited: 'Uitgenodigd · te kiezen zodra geaccepteerd',
    invite: 'Inspecteur uitnodigen',

    takeOn: {
        title: 'Ook als inspecteur werken?',
        description: 'Je kiest jezelf, maar je bent nog geen inspecteur.',
        gains: (keptRole: string) => [
            `Je krijgt de rol inspecteur erbij. ${keptRole} blijft je rol.`,
            'De keuringen die je zelf doet, staan in Mijn dag en op je tablet, ook zonder verbinding.',
            'Je staat met je afspraken in de planning, net als de andere inspecteurs.',
        ],
        without:
            'Zonder die rol kun je jezelf ook kiezen. Je doet de opname dan vanuit de keuring, niet vanuit Mijn dag.',
        confirm: 'Ja, ook als inspecteur werken',
        busy: 'Rol erbij zetten…',
        decline: 'Nee, niet nu',
        done: 'Je werkt nu ook als inspecteur. Mijn dag staat in het menu.',
        finish: 'Klaar',
        close: 'Sluiten',
    },

    invitePanel: {
        title: 'Inspecteur uitnodigen',
        description:
            'Je collega krijgt een mail met een link om bij dit bedrijf als inspecteur te werken.',
        name: 'Naam',
        namePlaceholder: 'Voor- en achternaam',
        nameRequired: 'Vul de naam van je collega in.',
        email: 'E-mailadres',
        emailPlaceholder: 'naam@voorbeeld.nl',
        emailRequired: 'Vul het e-mailadres van je collega in.',
        role: 'Rol',
        acceptFirst:
            'Kiezen kan zodra de uitnodiging is geaccepteerd: een keuring gaat alleen naar iemand die al bij dit bedrijf werkt. Tot dan staat je collega als uitgenodigd in de keuze.',
        submit: 'Uitnodiging versturen',
        busy: 'Versturen…',
        cancel: 'Annuleren',
        sent: (email: string, until: string) =>
            `Uitnodiging verstuurd naar ${email}. De link is geldig tot ${until}.`,
        sentNext: (name: string) =>
            `${name} staat nu als uitgenodigd in de keuze. Zodra de uitnodiging is geaccepteerd, kun je ${name} kiezen.`,
        finish: 'Klaar',
        close: 'Sluiten',
    },
} as const;
